import { render, staticRenderFns } from "./SpeedKitMessage.vue?vue&type=template&id=0ec8cc5b&scoped=true&"
import script from "./SpeedKitMessage.vue?vue&type=script&lang=js&"
export * from "./SpeedKitMessage.vue?vue&type=script&lang=js&"
import style0 from "./SpeedKitMessage.vue?vue&type=style&index=0&id=0ec8cc5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8cc5b",
  null
  
)

export default component.exports